import { render } from "./AudiencesHeader.vue?vue&type=template&id=2965cf46"
import script from "./AudiencesHeader.vue?vue&type=script&lang=js"
export * from "./AudiencesHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__